import { PageLinks } from "./page-links";
export const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

export const currency = process.env.GATSBY_CURRENCY;
export const country = "Kent";
export const defaultArea = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : "London";
export const defaultArea_Slug = defaultArea.toLowerCase().replace(/ /g, '-');

export const defaultArea_Newhomes = process.env.GATSBY_DEFAULT_AREA_NEWHOMES ? process.env.GATSBY_DEFAULT_AREA_NEWHOMES : "London";
export const defaultArea_Newhomes_Slug = defaultArea_Newhomes.toLowerCase().replace(/ /g, '-');

export const defaultResult_Link = "/find-a-property/";

export const site_name = process.env.GATSBY_SITE_NAME;
export const hasMyaccount = (process.env.GATSBY_MYACCOUNT || null) === '1' ? true : false;
export const hasPropertyCloud = (process.env.GATSBY_ENABLE_PROPERTYCLOUD || null) === '1' ? true : false;
export const postCodeAddressAPI = "ncZgV7m79UipxWpivISlAw37900";

export const IsAllAgentReview = true;
export const Default_View = "List"
export const slider_count = 3;
export const news_slider_count = 3;
export const site_bviewing_agent_id = "";


export const site_url = process.env.GATSBY_SITE_URL;
export const GOOGLE_MAP_API_KEY = process.env.GATSBY_GOOGLE_MAP_API_KEY;


export const Default_Map_Position = {
    lat: 55.9533,
    lng: -3.1883
};

export const LettingsAdminEmail = false;

export const epdqID = "";

export const search_result_sidebar = false;

export const SimilarProperty_FullWdth = true;

export const currency_converter = false;

export const branch_filter = true;

export const viewing_btn_text = "Enquire";

export const search_box_placeholder = "Enter a location";

export const footerVatDetails = "Miles & Barr Limited is registered in England & Wales.<br>Registered office address: 70 St. Mary Axe, London, EC3A 8BE.<br>Registered company number: 04991085. VAT Number: 825197612.<br>Part of Lomond";

export const mortgage_text = "These results are provided by Miles & Barr in partnership with Finamply and are only indicative based on a repayment mortgage product. The interest rate has been assumed to stay the same for the selected mortgage term. Repayments will be subject to the product provided and your circumstances. Your home or property may be repossessed if you do not keep up repayments on your mortgage."

export const valuation_thanks = `<p>We'll be in touch shortly to arrange a time for your local Miles & Barr expert to visit the property.<br /><br />Looking for a property to buy? Find it<a href="/${PageLinks.property_for_sale}/"> here</a>.</p>
<h4>My Account Action</h4>
<p>This exclusive report provides a unique up-to-date insight into the value of your property and analysis of the local market.</p>`

export const marketing_consent = `I agree to receive property-related news, updates and communications from ${process.env.GATSBY_SITE_NAME}. I understand I can unsubscribe at any time.`

export const Mail_Vars = {
    fb_link: "https://www.facebook.com/ChartersEstateAgent/",
    tw_link: "https://twitter.com/ChartersEstateA",
    company_phone: "02382 358580",
    available_time: "We're available from 9am - 6pm Monday to Thursday, 9am - 5:30pm Friday",
    address: "70 St. Mary Axe, London, EC3A 8BE."
}

// export const PageLinks = {
//     about: "about-brandvaughan",
//     general_enquiry: "general-enquiry",
//     news_insight: `about-brandvaughan/insights`,
//     branch_finder: "about-brandvaughan/branch-finder",
//     area_cover: "about-brandvaughan/areas-we-cover",
//     branch_contact: "contact-us",
//     team_contact: "contact-us",
//     teams: "about-brandvaughan/meet-the-team",
//     request_valuation: "property-valuation",
//     privacy_policy: "privacy-policy",
//     book_a_viewing: "book-a-viewing",
//     book_a_valuation: "property-valuation/home-visit-valuation",
//     send_to_friend: "send-to-friend",
//     property_to_rent: "property/to-rent",
//     property_for_sale: "property/for-sale",
//     reviews: "about-brandvaughan/customer-reviews",
//     property_management: "landlords/property-management",
//     financial_services: `financial-services`
// }

export const PropertySearchURL = {
    residential: {
        sales: "/property/for-sale/",
        lettings: "/property/to-rent/",
        newhomes: "/new-homes/for-sale/",
        newdevelopments: "/new-developments/for-sale/",
        investments: "/property-investments/for-sale/",
        students: "/property-students/to-rent/",
        collection: "/property-collection/for-sale/"
    },
    commercial: {
        sales: "/commercial-property/for-sale/",
        lettings: "/commercial-property/to-rent/",
    },
    auction: {
        sales: "/auctions/for-sale/"
    }
}

export const PropertyDetailsURL = {
    residential: {
        sales: "/property-for-sale/",
        lettings: "/property-to-rent/",
        newhomes: "/property-for-sale/",
        newdevelopments: "/new-developments-for-sale/"
    },
    commercial: {
        sales: "/commercial-property-for-sale/",
        lettings: "/commercial-property-to-rent/",
    },
    auction: {
        sales: "/auction-for-sale/"
    }
}

export const SearchTitle = {
    residential: {
        sales: "Properties for sale",
        lettings: "Properties to rent",
        newhomes: "New homes",
        newdevelopments: "New developments",
        investments: "Investment properties for sale",
        students: "Student properties for sale",
    },
    commercial: {
        sales: "Commercial properties for sale",
        lettings: "Commercial properties to rent",
    },
    auction: {
        sales: "Auction properties for sale"
    }
}

export const PopularSearch_Areas = [
    { value: "ashford", label: "Ashford" },
    { value: "canterbury", label: "Canterbury" },
    { value: "birchington", label: "Birchington" },
    { value: "broadstairs", label: "Broadstairs" }
]

export const PopularSearch_Types = [
    { value: "house", label: "Houses" },
    { value: "apartment", label: "Apartments" },
    { value: "bungalow", label: "Bungalows" },
    { value: "maisonette", label: "Maisonettes" }
]

export const sortByList = [
    { value: "Newest", label: "Newest" },
    { value: "HighestPrice", label: "Highest Price" },
    { value: "LowestPrice", label: "Lowest Price" },
    { value: "Oldest", label: "Oldest" },
]

export const SearchType = {
    sales: "For Sale",
    lettings: "To Rent",
    newhomes: "New homes",
    investments: "Investments",
    students: "Students",
    commercial_sales: "Commercial Sales",
    commercial_lettings: "Commercial Lettings",
    auction_sales: "Auctions",
    collection: "Exclusive",
    newdevelopments: "Developments",
}

export const FurnishedType = [
    { value: '', label: 'Select type' },
    { value: 'furnished', label: 'Furnished' },
    { value: 'unfurnished', label: 'Unfurnished' },
    { value: 'part-furnished', label: 'Part furnished' },
]

export const DepartmentType = [
    { value: '', label: 'Select type' },
    { value: 'residential', label: 'Residential' },
    { value: 'commercial', label: 'Commercial' },
]

export const leadooPageSlot = {
    sell_property: "Sellers",
    landlords: "Landlords",
    sales: "Sale listings",
    lettings: "Rental listing",
    branch_finder: "Branch finder",
    general_enquiry: "General enquiry",
    valuation: "Valuation",
    home: "Valuation"
}
